import { humanizeStatus } from '../../lib/format.js'

const statusTone = {
  ACTIVE: 'border-emerald-300 bg-emerald-50 text-emerald-900 font-bold shadow-2xs',
  APPROVED: 'border-emerald-300 bg-emerald-50 text-emerald-900 font-bold shadow-2xs',
  VALIDATED: 'border-emerald-300 bg-emerald-50 text-emerald-900 font-bold shadow-2xs',
  VERIFIED: 'border-emerald-300 bg-emerald-50 text-emerald-900 font-bold shadow-2xs',
  PAID: 'border-emerald-300 bg-emerald-50 text-emerald-900 font-bold shadow-2xs',
  PENDING: 'border-amber-300 bg-amber-50 text-amber-950 font-bold shadow-2xs',
  PENDING_REVIEW: 'border-amber-300 bg-amber-50 text-amber-950 font-bold shadow-2xs',
  UNDER_REVIEW: 'border-amber-300 bg-amber-50 text-amber-950 font-bold shadow-2xs',
  PROCESSING: 'border-blue-300 bg-blue-50 text-blue-950 font-bold shadow-2xs',
  IN_PROGRESS: 'border-blue-300 bg-blue-50 text-blue-950 font-bold shadow-2xs',
  SUBMITTED: 'border-indigo-300 bg-indigo-50 text-indigo-950 font-bold shadow-2xs',
  PENAYANGAN: 'border-indigo-300 bg-indigo-50 text-indigo-950 font-bold shadow-2xs',
  REVISION_REQUIRED: 'border-orange-300 bg-orange-50 text-orange-950 font-bold shadow-2xs',
  REJECTED: 'border-red-300 bg-red-50 text-red-950 font-bold shadow-2xs',
  CANCELLED: 'border-red-300 bg-red-50 text-red-950 font-bold shadow-2xs',
  PAUSED: 'border-slate-300 bg-slate-100 text-slate-800 font-bold shadow-2xs',
  DRAFT: 'border-slate-300 bg-slate-100 text-slate-800 font-bold shadow-2xs',
  COMPLETED: 'border-emerald-300 bg-emerald-50 text-emerald-900 font-bold shadow-2xs',
  ARCHIVED: 'border-rose-300 bg-rose-50 text-rose-950 font-bold shadow-2xs',
  DELETED: 'border-rose-300 bg-rose-50 text-rose-950 font-bold shadow-2xs',
  UNVERIFIED: 'border-slate-300 bg-slate-100 text-slate-800 font-bold shadow-2xs',
}

export function Badge({ children, status, variant = 'default', className = '' }) {
  const content = children ?? humanizeStatus(status)
  
  let tone = ''
  if (status) {
    tone = statusTone[status] || 'border-slate-300 bg-slate-50 text-slate-800 font-bold shadow-2xs'
  } else if (variant === 'overlay') {
    tone = 'border-white/25 bg-black/80 text-white shadow-md backdrop-blur-md font-bold'
  } else {
    tone = 'border-blue-200 bg-blue-50 text-blue-800 shadow-2xs font-semibold'
  }

  return (
    <span className={`inline-flex min-h-6 max-w-full items-center rounded-full border px-2.5 py-0.5 text-[11px] leading-4 ${tone} ${className}`}>
      {content}
    </span>
  )
}

export function TierBadge({ tier = 'SILVER', size = 'sm', className = '' }) {
  const upper = String(tier || 'SILVER').toUpperCase()
  const styles = {
    SILVER: 'border-slate-300 bg-slate-100 text-slate-800 font-extrabold shadow-2xs',
    GOLD: 'border-amber-300 bg-amber-50 text-amber-900 font-extrabold shadow-2xs',
    PLATINUM: 'border-purple-300 bg-purple-50 text-purple-900 font-extrabold shadow-2xs',
    DIAMOND: 'border-cyan-300 bg-cyan-50 text-cyan-900 font-extrabold shadow-2xs',
  }
  const tone = styles[upper] || styles.SILVER

  const sizeClasses =
    size === 'xs'
      ? 'px-2.5 py-0.5 text-[10px] tracking-wider'
      : size === 'lg'
      ? 'px-3.5 py-1 text-xs tracking-wider'
      : 'px-3 py-0.5 text-[11px] tracking-wider'

  return (
    <span className={`inline-flex items-center justify-center font-extrabold uppercase rounded-full border ${sizeClasses} ${tone} ${className}`}>
      {upper}
    </span>
  )
}
